<template>

    <section>
        <el-tabs v-model="activeName">
            <el-tab-pane label="请求响应" name="requestresponse">
                <el-table
                :data="rrData.filter(data => !rrSearch || data.content.toLowerCase().includes(rrSearch.toLowerCase()))"
                v-loading="rrListLoading"
                height="1000"
                size="mini"
                style="width: 100%">
                    <el-table-column
                            label="Datetime"
                            prop="datetime" width="150">
                    </el-table-column>
                    <el-table-column>
                        <template slot="header" inline slot-scope="scope">
                            <el-row>
                                <el-col :span="8">
                                    <el-input
                                        v-model="rrSearch"
                                        size="mini"
                                        clearable
                                        placeholder="输入关键字搜索"/> 
                                </el-col>
                            </el-row>
                        </template>
                        <template  slot-scope="scope">
                            <span :class="scope.row.logColor"
                                v-html="scope.row.content"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="AOP" name="aop">
                <el-table
                :data="aopData.filter(data => !aopSearch || data.content.toLowerCase().includes(aopSearch.toLowerCase()))"
                v-loading="aopListLoading"
                size="mini"
                height="1000"
                style="width: 100%">
                    <el-table-column
                            label="Datetime"
                            prop="datetime" width="150">
                    </el-table-column>
                    <el-table-column>
                        <template slot="header" inline slot-scope="scope">
                            <el-row>
                                <el-col :span="8">
                                    <el-input
                                        v-model="aopSearch"
                                        size="mini"
                                        clearable
                                        placeholder="输入关键字搜索"/> 
                                </el-col>
                            </el-row>
                        </template>
                        <template  slot-scope="scope">
                            <span :class="scope.row.logColor"
                                v-html="scope.row.content"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="SQL" name="sql">
                <el-table
                :data="sqlData.filter(data => !sqlSearch || data.content.toLowerCase().includes(sqlSearch.toLowerCase()))"
                v-loading="sqlListLoading"
                size="mini"
                height="1000"
                style="width: 100%">
                    <el-table-column
                            label="Datetime"
                            prop="datetime" width="150">
                    </el-table-column>
                    <el-table-column>
                        <template slot="header" inline slot-scope="scope">
                            <el-row>
                                <el-col :span="8">
                                    <el-input
                                        v-model="sqlSearch"
                                        size="mini"
                                        clearable
                                        placeholder="输入关键字搜索"/> 
                                </el-col>
                            </el-row>
                        </template>
                        <template  slot-scope="scope">
                            <span :class="scope.row.logColor"
                                v-html="scope.row.content"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="异常" name="exception">
                <el-table
                :data="excepData.filter(data => !excepSearch || data.content.toLowerCase().includes(excepSearch.toLowerCase()))"
                v-loading="excepListLoading"
                size="mini"
                height="1000"
                style="width: 100%">
                    <el-table-column
                            label="Datetime"
                            prop="datetime" width="150">
                    </el-table-column>
                    <el-table-column>
                        <template slot="header" inline slot-scope="scope">
                            <el-row>
                                <el-col :span="8">
                                    <el-input
                                        v-model="excepSearch"
                                        size="mini"
                                        clearable
                                        placeholder="输入关键字搜索"/> 
                                </el-col>
                            </el-row>
                        </template>
                        <template  slot-scope="scope">
                            <span :class="scope.row.logColor"
                                v-html="scope.row.content"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </section>
</template>

<script>
    import util from '../../../util/date'
    import {getLogs} from '../../api/api';
    import {BaseRouterUrl} from '../../api/axios_config';
    import * as signalR from "@aspnet/signalr";

    export default {
        data() {
            return {
                activeName: 'requestresponse',
                rrData: [],
                rrSearch: '',
                rrListLoading: true,
                aopData: [],
                aopSearch: '',
                aopListLoading: true,
                sqlData: [],
                sqlSearch: '',
                sqlListLoading: true,
                excepData: [],
                excepSearch: '',
                excepListLoading: true,
                connection: "",
                t: "",
                signalrConnCount: 0

            }
        },
        methods: {
            formatCreateTime: function (row, column) {
                return (!row.tdCreatetime || row.tdCreatetime == '') ? '' : util.formatDate.format(new Date(row.tdCreatetime), 'yyyy-MM-dd');
            },
            handleCurrentChange(val) {
                this.page = val;
                //this.getRoles();
            },
            //获取用户列表
            //getRoles() {
                // let thisvue=this;
                // this.listLoading = true;
                // getLogs();
                // getLogs(para).then((res) => {
                //     // this.tableData = res.data.response;
                //     thisvue.connection.start().then(() => {
                //         console.log('start')
                //         // thisvue.connection.invoke('GetLatestCount', 1).catch(function (err) {
                //         //     return console.error(err);
                //         // });

                //         // transactionConnection.invoke('JoinGroup', 'ClientAccountTransaction').catch(err => console.error(err.toString()));

                //     });


                // });
            //},
            // submitCard: function () {
            //     if (this.userName && this.userMessage) {
            //         this.connection.invoke('SendMessage', this.userName, this.userMessage).catch(function (err) {
            //             // return console.error(err);
            //         });

            //     }
            // },
            getLogsData: function () {
                let random = Math.random().toString();
                this.connection.invoke('GetLatestLogs', random).catch(function (err) {
                    return random;
                });
            }

        },
        created: function () {
            let _this = this;

            _this.connection = new signalR.HubConnectionBuilder()
                .withUrl(`/api/chatHub`)
                //.configureLogging(signalR.LogLevel.Information)
                .build();
            
            start();

            _this.connection.onclose(start);

            _this.connection.on('ReceiveMessage', function (res) {
                
                if(res.type==='requestresponse'){
                    _this.rrListLoading = false;
                    _this.rrData = res.data;
                } else if(res.type==='aop'){
                    _this.aopListLoading = false;
                    _this.aopData = res.data;
                }else if(res.type==='sql'){
                    _this.sqlListLoading =false;
                    _this.sqlData = res.data;
                }else if(res.type==='exception'){
                    _this.excepListLoading =false;
                    _this.excepData = res.data;
                }
            });

            _this.connection.on('ReceiveUpdate', function (res) {
                if(res.type==='requestresponse'){
                    _this.rrListLoading = false;
                    _this.rrData = res.data;
                } else if(res.type==='aop'){
                    _this.aopListLoading = false;
                    _this.aopData = res.data;
                }else if(res.type==='sql'){
                    _this.sqlListLoading =false;
                    _this.sqlData = res.data;
                }else if(res.type==='exception'){
                    _this.excepListLoading =false;
                    _this.excepData = res.data;
                }
                window.clearInterval(this.t)
            });

            async function start() {
                try {
                    await _this.connection.start();
                    console.log("SignalR Connected.");
                } catch (err) {
                    console.log("SignalR Connect Failed");
                    _this.signalrConnCount = _this.signalrConnCount+1;
                    if(_this.signalrConnCount<5){
                        setTimeout(start, 5000);
                    }
                }
            };
        },
        mounted() {
             this.t =  setTimeout(() => {
                 this.getLogsData();
            }, 1000);

        },
        beforeDestroy() {
            window.clearInterval(this.t)
            this.connection.stop();
        }
    }

</script>

<style scoped>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 30%;
    }

    .EXC {
        color: red;
    }
</style>
